<template>
  <v-container>
    <v-row
      justify="center"
    >
      <v-col
        align="center"
        cols="10"
      >
        <v-sheet
          align="start"
          color="transparent"
        >
          <h1 class="text-h3 my-2 font-weight-light">404</h1>
          foobar
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'PageNotFound',

  components: {},

  data: () => ({
    //
  }),
};
</script>
